<template>
  <div :class="['gallery', galleryClass]">
    <!--Regular gallery-->
    <div class="gallery-row" v-if="galleryClass != 'one-photo'">
      <div class="gallery-item" v-for="(image, i) in gallery" :key="i" :style="`background-image:url(${getSrc(image.idFile)});`">
        <button class="gallery-button" @click="galleryFullview(i)"><i class="icon-fullview"></i></button>
      </div>
    </div>

    <!--Just one photo is shown-->
    <div class="gallery-row" v-else>
      <div class="gallery-item" v-for="(image, i) in gallery" :key="i">
        <img :src="image.src" />
        <button class="gallery-button" @click="galleryFullview(i)"><i class="icon-fullview"></i></button>
      </div>
    </div>

    <transition name="fade">
      <div class="popup-wrapper" v-if="gallery && gallery.length && galleryShow">
        <div class="popup-overlay" @click="galleryShow = false" />
        <div class="gallery-popup">
          <button class="gallery-popup-close" @click="galleryShow = false"><i class="icon-close"></i></button>
          <ImageWrapper :file="gallery[galleryIndex].idFile"></ImageWrapper>
          <div class="slider-nav">
            <button class="slider-prev" :class="{'inactive': galleryIndex == 0}" @click="galleryIndex--"></button>
            <ul class="slider-paginator">
              <li v-for="i in gallery.length" :key="i" :class="{active: i == galleryIndex + 1}" @click="galleryIndex = i-1" />
            </ul>
            <button class="slider-next" @click="galleryIndex++" :class="{'inactive': gallery.length == galleryIndex + 1}"></button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
import settings from "@/settings";
export default {
  name: "Gallery",
  components: {ImageWrapper},
  props: ['gallery', 'galleryClass'],
  data () {
    return {
      galleryIndex: 0,
      galleryShow: false,
    }
  },
  methods: {
    galleryFullview (i) {
      this.galleryIndex = i
      this.galleryShow = true
    },
    getSrc(idFile) {
      return `${settings.API_BASE_PATH}/image/${idFile}`
    }
  }
}
</script>

<style scoped>

</style>
